// import logo from '../logo.svg';

// const Header = ({ onContactClick, onHomeClick, onFAQClick }) => {
//     return (
//       <header className="main-header">
//         <div className="header-container">
//           <div className="header-left">
//             <div className="logo-wrapper">
//               <img src={logo} alt="Logo" className="header-logo" onClick={onHomeClick} style={{ cursor: 'pointer' }} />
//             </div>
//           </div>
//           <nav className="header-nav">
//             <a href="#home" className="nav-link active" onClick={(e) => { e.preventDefault(); onHomeClick(); }}>Home</a>
//             <a href="#our-apps" className="nav-link">Featured Apps</a>
//             <a href="#about" className="nav-link">About</a>
//             <a href="#faq" className="nav-link" onClick={(e) => { e.preventDefault(); if (onFAQClick) onFAQClick(); }}>FAQ</a>
//           </nav>
//           <div className="header-right">
//             <button className="header-contact-btn" onClick={onContactClick}>Book Appointment ?</button>
//           </div>
//         </div>
//       </header>
//     );
//   }

//   export default Header;

import { useState } from 'react';
import { useLocation } from "react-router-dom";
import Logo from '../assets/images/dilabslogo.png'

const Header = ({ onContactClick, onHomeClick, onFAQClick }) => {
  const [menuOpen, setMenuOpen] = useState(false);

  const location = useLocation();
  const currentSection = location.hash?.replace("#", "") || "home";


  const handleScroll = (id) => {
    setMenuOpen(false);
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: "smooth" });
      return;
    }

    // Return from Contact/Privacy/Terms, then scroll to the requested section.
    window.location.hash = "#home";
    setTimeout(() => {
      document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
    }, 100);
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <>
      <header className="main-header">
        <div className="header-container">
          <div className="header-left">
            <div className="logo-wrapper">
              <img 
                src={Logo} 
                alt="Logo" 
                className="header-logo" 
                onClick={onHomeClick} 
                style={{ cursor: 'pointer' }} 
              />
            </div>
          </div>

          {/* Desktop Navigation */}
          <nav className="header-nav">
            <a 
              className={`nav-link ${currentSection === "home" ? "active" : ""}`}
              onClick={() => handleScroll("home")}
              href="#home"
            >
              Home
            </a>
            <a 
              className={`nav-link ${currentSection === "about" ? "active" : ""}`}
              onClick={() => handleScroll("about")}
              href="#about"
            >
              About Us
            </a>
            <a 
              className={`nav-link ${currentSection === "our-apps" ? "active" : ""}`}
              onClick={() => handleScroll("our-apps")}
              href="#our-apps"
            >
              Our Apps
            </a>
            <a
              className={`nav-link ${currentSection === "why-choose-us" ? "active" : ""}`}
              onClick={() => handleScroll("why-choose-us")}
              href="#why-choose-us"
            >
              Why Choose Us
            </a>
            <a 
              className={`nav-link ${currentSection === "faq" ? "active" : ""}`}
              onClick={() => handleScroll("faq")}
              href="#faq"
            >
              FAQ
            </a>
          </nav>

          <div className="header-right">
            <button className="header-contact-btn" onClick={onContactClick}>
              Contact Us
            </button>
          </div>

          {/* Mobile Menu Toggle */}
          <button 
            className={`menu-toggle ${menuOpen ? 'open' : ''}`}
            onClick={toggleMenu}
            aria-label="Toggle menu"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>

      </header>

      {/* Mobile Menu Dropdown from Top */}
      <div className={`mobile-menu-wrapper ${menuOpen ? 'open' : ''}`}>
        <div className="mobile-menu-content">
          <nav className="mobile-nav">
            <a 
              className={`nav-link ${currentSection === "home" ? "active" : ""}`}
              onClick={() => handleScroll("home")}
              href="#home"
            >
              Home
            </a>
            <a 
              className={`nav-link ${currentSection === "about" ? "active" : ""}`}
              onClick={() => handleScroll("about")}
              href="#about"
            >
              About Us
            </a>
            <a 
              className={`nav-link ${currentSection === "our-apps" ? "active" : ""}`}
              onClick={() => handleScroll("our-apps")}
              href="#our-apps"
            >
              Our Apps
            </a>
            <a
              className={`nav-link ${currentSection === "why-choose-us" ? "active" : ""}`}
              onClick={() => handleScroll("why-choose-us")}
              href="#why-choose-us"
            >
              Why Choose Us
            </a>
            <a 
              className={`nav-link ${currentSection === "faq" ? "active" : ""}`}
              onClick={() => handleScroll("faq")}
              href="#faq"
            >
              FAQ
            </a>
            <a
              className={`nav-link ${currentSection === "contact" ? "active" : ""}`}
              href="#contact"
              onClick={(e) => {
                e.preventDefault();
                setMenuOpen(false);
                onContactClick();
              }}
            >
              Contact Us
            </a>
          </nav>
        </div>
      </div>

      {/* Overlay */}
      <div 
        className={`overlay ${menuOpen ? 'open' : ''}`}
        onClick={() => setMenuOpen(false)}
      ></div>
    </>
  );
};

export default Header;
